import { post, get, baseURL } from "@/utils/request";

// i18n API
export const getHomeConfig = () => post(`/homeConfig/homeConfig`);

export const getCustomerServiceList= () => post(`/customerService/getCustomerServiceList`);


//Home config
export const getHomePageData = () => get(`/common/getHomePageData`);

export const backendRechargeClaim = (data: any) => post(`/activity/backendRechargeClaim`, data);